import { Controller } from "stimulus"
import notify from "../../packs/notify"
import axios from "axios";
import i18next from "i18next";
export default class extends Controller {
  static targets = ["paymentBalance", "paymentAmount", "clientReference", "submitButton"]

  connect(){
    this.initValidation()
  }

  initValidation(){
    const paymentAmountId = this.paymentAmountTarget.id
    $(this.element).validate( {
      ignore: [],
      errorPlacement: function(error, element) {
        switch (element.attr("id")) {
          case paymentAmountId:
            element.parent().parent().append(error);
            break;
          default:
            element.parent().append(error);
            break;
        }
      }
    })

    $(this.clientReferenceTarget).rules('add', {
      maxlength: this.clientReferenceValidationRules.maxlength
    })

    $(this.paymentAmountTarget).rules('add', {
      required: true,
    })
  }

  makePayment(event){
    event.preventDefault();
    if(!$(this.element).valid()) return

    const ticket = this.element.querySelector('input#Userpart1');
    const ticketName = this.element.querySelector('input#Userpart2');
    const amount = this.element.querySelector('input#PaymentAmount');
    const cancelUrl = this.element.querySelector('input#CancelUrl');

    this.submitButtonTarget.disabled = true
    axios({
      url: '/fis/generate_token.json', 
      method: 'POST',
      data: {
        amount: this.paymentAmountTarget.value, 
        client_reference: this.clientReferenceTarget.value
      }
    })
    .then(response =>{
      const updatedCancelUrl = cancelUrl.value + '?UserPart2=' + response.data.ticket_name
      ticket.value = response.data.ticket
      ticketName.value = response.data.ticket_name
      amount.value = response.data.amount
      cancelUrl.value = updatedCancelUrl

      this.element.submit()
    })
    .catch(()=>{
      notify({message: i18next.t('An error occured while processing payment! Your account has not been charged.'), status: 'error', parentElement: this.pageAlertElement})
    }).finally(()=>{
      this.submitButtonTarget.disabled = false
    })
  }

  get pageAlertElement(){
    return document.getElementById('page-alert')
  }

  get clientReferenceValidationRules(){
    if(!this.clientReferenceTarget.dataset.validationRules) throw 'Provide client refrence validation'
    
    return JSON.parse(this.clientReferenceTarget.dataset.validationRules)
  }
}